var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"label-container"},[(_vm.icon)?_c('v-icon',{attrs:{"small":"","color":_vm.color}},[_vm._v(_vm._s(_vm.icon))]):_vm._e(),(_vm.title)?_c('div',{staticClass:"body-2"},[_vm._v(_vm._s(_vm.title))]):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }